import {
	JOB_TITLE_ACRONYMS,
	JOB_TITLE_MINOR_WORDS
} from '@/core/constants/jobTitle';

export const formatJobTitle = (
	value: string,
	locale: Intl.LocalesArgument = 'en-US'
): string => {
	let wordIndex = 0;

	return value.replace(/\S+/g, word => {
		const isFirstWord = wordIndex++ === 0;

		if (JOB_TITLE_ACRONYMS.has(word)) return word;

		const lower = word.toLocaleLowerCase(locale);
		if (!isFirstWord && JOB_TITLE_MINOR_WORDS.has(lower)) return lower;

		return `${lower.charAt(0).toLocaleUpperCase(locale)}${lower.slice(1)}`;
	});
};
